/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Accessuser2Inputs */

const en_coinvestments_share_accessuser2 = /** @type {(inputs: Coinvestments_Share_Accessuser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 user`)
};

/**
* | output |
* | --- |
* | "1 user" |
*
* @param {Coinvestments_Share_Accessuser2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_accessuser2 = /** @type {((inputs?: Coinvestments_Share_Accessuser2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Accessuser2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_accessuser2(inputs)
});
export { coinvestments_share_accessuser2 as "coInvestments_share_accessUser" }